define('shared/connect-to-actions',[
	"jquery", "underscore", "backbone", "react",
	"actions/assignments",
	"actions/buncees",
	"actions/classes",
	"actions/clips",
	"actions/email-activities",
	"actions/email-activity-details",
	"actions/groups",
	"actions/notifications",
	"actions/organizer",
	"actions/submissions",
	"actions/students",
	"actions/contacts",
	"actions/rsvps",
	"actions/rsvp-summaries",
	"actions/boards",
	"actions/announcements",
	"actions/badges",
	"actions/shared-entities",
	"actions/followed-entities",
	"actions/ideas-lab",
	"actions/streaks",
	"actions/stats",
	"actions/sessions",
	"actions/resource-buncees"
],
function($,_,Backbone,React, Assignments, Buncees, Classes, Clips, EmailActivities, EmailActivityDetails, Groups, Notifications, Organizer, Submissions, Students, Contacts, RSVPs, RSVPSummaries, Boards, Announcements, Badges, Shared, Followed, IdeasLab, Streaks, Stats, Sessions, ResourceBuncees) {
	var connectToActions = (function() {
		var instance;

		function init() {
			// Private methods and variables

			return {
				// Public methods and variables
				"assignments": new Assignments(),
				"buncees": new Buncees(),
				"classes": new Classes(),
				"clips": new Clips(),
				"email-activities": new EmailActivities(),
				"email-activity-details": new EmailActivityDetails(),
				"groups": new Groups(),
				"notifications": new Notifications(),
				"organizer": new Organizer(),
				"submissions": new Submissions(),
				"students": new Students(),
				"contacts": new Contacts(),
				"rsvps": new RSVPs(),
				"rsvp-summaries": new RSVPSummaries(),
				"boards": new Boards(),
				"announcements": new Announcements(),
				"badges": new Badges(),
				"shared": new Shared(),
				"followed": new Followed(),
				"ideas-lab": new IdeasLab(),
				"streaks": new Streaks(),
				"stats": new Stats(),
				"sessions": new Sessions(),
				"resources": new ResourceBuncees(),
			}
		}

		return {
			getInstance: function() {
				if(!instance)
					return init();

				return instance;
			}
		}
	})();

	return connectToActions.getInstance();
});
